import {
    CreatorAccommodationStepObject,
    CreatorStepObject,
    SelfcareStepObject,
    UnlimitedCardStepObject,
    UnlimitedRenewStepObject,
    VouchersStepObject,
} from 'routes/steps'
import { useApp } from 'store/steps'
import Box from 'components/shared/Box'
import {
    CreatorAccommodationStep,
    GlobalStep,
    SelfcareStep,
    Step,
    UnlimitedCardStep,
    UnlimitedRenewStep,
    VouchersStep,
} from 'store/general-slice/types'
import { DesktopNavigationContent } from './DesktopNavigationContent'

interface DesktopNavigationProps {
    steps:
        | CreatorStepObject[]
        | CreatorAccommodationStepObject[]
        | SelfcareStepObject[]
        | UnlimitedCardStepObject[]
        | UnlimitedRenewStepObject[]
        | VouchersStepObject[]
    stepId?:
        | Step
        | CreatorAccommodationStep
        | SelfcareStep
        | GlobalStep
        | UnlimitedCardStep
        | UnlimitedRenewStep
        | VouchersStep
}

const DesktopNavigation = ({ steps, stepId }: DesktopNavigationProps) => {
    const { goBackToStep } = useApp()
    let activeIndex = -1

    const handleGoBack = (
        id:
            | SelfcareStep
            | Step
            | CreatorAccommodationStep
            | UnlimitedCardStep
            | UnlimitedRenewStep
            | VouchersStep
    ) => goBackToStep(id)

    return (
        <Box as="ul" direction="row" gap={[24, 64]} mt={[0, 48]}>
            {steps.map((step, index) => {
                const { id, navigationIndex, title } = step
                if (!navigationIndex) return null

                const isActive =
                    stepId === id ||
                    (stepId === 'accommodation_details' &&
                        id === 'accommodation')

                if (isActive) {
                    activeIndex = index
                }

                const isCompleted = activeIndex === -1
                const isClickable = id !== 'renew_verification'

                return (
                    <Box key={index}>
                        <DesktopNavigationContent
                            isActive={isActive}
                            isCompleted={isCompleted}
                            navigationIndex={navigationIndex}
                            title={title}
                            id={id}
                            onClick={
                                isClickable
                                    ? () => isCompleted && handleGoBack(id)
                                    : undefined
                            }
                        />
                    </Box>
                )
            })}
        </Box>
    )
}

export default DesktopNavigation
